import { compose } from "redux";
import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";
import { IAction } from "../../../models/Action";
import { immutableSet } from "../../../utils/immutable";
import { actionTypes } from "./actions";
import { STATE_IDENTIFIER } from "./constants";
import emptyState from "./emptyState";

const {
  DOMAINS,
  QUESTIONS,
  QUESTIONS_LOADER,
  ANSWER,
  USER,
  OTP,
  REQUEST_STATE_QUESTION,
  REQUEST_STATE_OTP,
  TOKEN_TMP,
  TOKEN_TYPE,
  PASSW_POLICY,
  RETRYS,
  REQUEST_STATE_PASSWORD,
  GENERATE_OTP_CALL_STATE,
  GENERATE_OTP_RECEIVER,
  FIRST_ACCESS,
  OLD_PASSWORD,
} = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.SET_FIRST_ACCESS]: (state: any, action: any) =>
    immutableSet([FIRST_ACCESS], action.payload, state),

  [actionTypes.SET_OLD_PASSWORD]: (state: any, action: any) =>
    immutableSet([OLD_PASSWORD], action.payload, state),

  [actionTypes.SET_TEMP_TOKEN]: (state: any, action: any) =>
    immutableSet([TOKEN_TMP], action.payload, state),

  [actionTypes.GENERATE_LOGIN_OTP]: (state: any, action: any) =>
    immutableSet([GENERATE_OTP_CALL_STATE], IResponseState.PENDING, state),
  [actionTypes.GENERATE_LOGIN_OTP_SUCCESS]: (state: any, action: any) =>
    compose(
      immutableSet([GENERATE_OTP_CALL_STATE], IResponseState.SUCCESS),
      immutableSet([GENERATE_OTP_RECEIVER], action.payload)
    )(state),
  [actionTypes.GENERATE_LOGIN_OTP_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([GENERATE_OTP_CALL_STATE], IResponseState.ERROR),
      immutableSet([GENERATE_OTP_RECEIVER], action.payload)
    )(state),

  [actionTypes.GET_DOMAINS_SUCCESS]: (state: any, action: any) =>
    immutableSet([DOMAINS], action.payload, state),
  [actionTypes.GET_DOMAINS_FAILURE]: (state: any, action: any) =>
    immutableSet([DOMAINS], [], state),

  [actionTypes.SET_USER]: (state: any, action: any) =>
    immutableSet([USER], action.payload, state),

  [actionTypes.SET_OTP]: (state: any, action: any) =>
    immutableSet([OTP], action.payload, state),

  [actionTypes.GET_QUESTIONS_LOGIN]: (state: any, action: any) =>
    immutableSet([QUESTIONS_LOADER], true, state),
  [actionTypes.GET_QUESTIONS_LOGIN_SUCCESS]: (state: any, action: any) =>
    compose(
      immutableSet([QUESTIONS], action.payload),
      immutableSet([QUESTIONS_LOADER], false)
    )(state),
  [actionTypes.GET_QUESTIONS_LOGIN_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([QUESTIONS], []),
      immutableSet([QUESTIONS_LOADER], false)
    )(state),

  [actionTypes.DISPATCH_LOGIN_ANSWER]: (state: any, action: any) =>
    immutableSet(
      [QUESTIONS, action.payload.index, ANSWER],
      action.payload.answer,
      state
    ),

  [actionTypes.RESET_LOGIN_STATE]: (state: any, action: any) =>
    compose(
      immutableSet([QUESTIONS], []),
      immutableSet([USER], ""),
      immutableSet([OTP], ""),
      immutableSet([REQUEST_STATE_QUESTION], IResponseState.PENDING),
      immutableSet([TOKEN_TMP], ""),
      immutableSet([TOKEN_TYPE], ""),
      immutableSet([PASSW_POLICY], {})
    )(state),

  [actionTypes.POST_LOGIN_ANSWER]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE_QUESTION], IResponseState.PENDING, state),
  [actionTypes.POST_LOGIN_ANSWER_SUCCESS]: (state: any, action: any) => {
    return compose(
      immutableSet([REQUEST_STATE_QUESTION], IResponseState.SUCCESS),
      immutableSet([TOKEN_TMP], action.payload.access_token),
      immutableSet([TOKEN_TYPE], action.payload.token_type)
    )(state);
  },
  [actionTypes.POST_LOGIN_ANSWER_FAILURE]: (state: any, action: any) => {
    return immutableSet([REQUEST_STATE_QUESTION], IResponseState.ERROR, state);
  },

  [actionTypes.POST_LOGIN_OTP]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE_OTP], IResponseState.PENDING, state),
  [actionTypes.POST_LOGIN_OTP_SUCCESS]: (state: any, action: any) => {
    return compose(
      immutableSet([REQUEST_STATE_OTP], IResponseState.SUCCESS),
      immutableSet([TOKEN_TMP], action.payload.access_token),
      immutableSet([TOKEN_TYPE], action.payload.token_type)
    )(state);
  },
  [actionTypes.POST_LOGIN_OTP_FAILURE]: (state: any, action: any) => {
    let retrysLeft = state[`${RETRYS}`];
    retrysLeft--;
    return compose(
      immutableSet([REQUEST_STATE_OTP], IResponseState.ERROR),
      immutableSet([RETRYS], retrysLeft)
    )(state);
  },

  [actionTypes.GET_PASSWORD_POLICY_SUCCESS]: (state: any, action: any) =>
    immutableSet([PASSW_POLICY], action.payload, state),

  [actionTypes.RESET_MODAL_OTP_STATE]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE_OTP], IResponseState.PENDING, state),

  [actionTypes.POST_PASSWORD]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE_PASSWORD], IResponseState.PENDING, state),
  [actionTypes.POST_PASSWORD_SUCCESS]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE_PASSWORD], IResponseState.SUCCESS, state),
  [actionTypes.POST_PASSWORD_FAILURE]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE_PASSWORD], IResponseState.ERROR, state),

  [actionTypes.CHANGE_FIRST_PWD]: (state: any, action: any) =>
    immutableSet([REQUEST_STATE_PASSWORD], IResponseState.PENDING, state),
  [actionTypes.CHANGE_FIRST_PWD_SUCCESS]: (state: any, action: any) => {
    return compose(
      immutableSet([REQUEST_STATE_PASSWORD], IResponseState.SUCCESS),
      immutableSet([FIRST_ACCESS], false)
    )(state);
  },
  [actionTypes.CHANGE_FIRST_PWD_FAILURE]: (state: any, action: any) => {
   /* return compose(
      immutableSet([REQUEST_STATE_PASSWORD], IResponseState.ERROR),
      immutableSet([FIRST_ACCESS], false)
    )(state);*/
    //Risolve il problema del first access se non chiudi popup
    return immutableSet([REQUEST_STATE_PASSWORD], IResponseState.ERROR, state);
  },
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    (action.payload.location.pathname === "/login" ||
      action.payload.location.pathname === "/welcome")
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
